import { render } from "./LinkBlock.vue?vue&type=template&id=6d342b1c"
import script from "./LinkBlock.vue?vue&type=script&lang=js"
export * from "./LinkBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vue/components/LinkBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d342b1c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d342b1c', __exports__)) {
    api.reload('6d342b1c', __exports__)
  }
  
  module.hot.accept("./LinkBlock.vue?vue&type=template&id=6d342b1c", () => {
    api.rerender('6d342b1c', render)
  })

}


export default __exports__